import { useEffect } from 'react';

import { App } from '@/App';
import { AuthProvider } from '@/auth';
import { AwakeProvider } from '@/awake';
import { LangProvider } from '@/lang';
import { haptic } from '@/platform';
import { ThemeProvider } from '@/theme';
import { UpdateGate } from '@/components/UpdateGate';

function usePressHaptics(): void {
  useEffect(() => {
    const onPress = (e: MouseEvent) => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      const button = target.closest('button');
      if (!button || button.hasAttribute('disabled')) return;
      haptic.impact();
    };
    document.addEventListener('click', onPress, true);
    return () => document.removeEventListener('click', onPress, true);
  }, []);
}

export function Root() {
  usePressHaptics();
  return (
    <ThemeProvider>
      <AuthProvider>
        <LangProvider>
          <UpdateGate>
            <AwakeProvider>
              <App />
            </AwakeProvider>
          </UpdateGate>
        </LangProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
